import { Typography, Card, Divider, Box } from '@mui/material';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import BackButton from '../../../components/Buttons/BackButton';
import TitleLayout from '../../../components/layout/TitleLayout';
import SkeletonWrapper from '../../../components/Skeletons/SkeletonWrapper';
import RenderForm from '../../../components/TemplatesForms/RenderForm';
import HttpService from '../../../services/HttpService';

function ViewFromScratchRequest() {
  const params = useParams();
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const navigate = useNavigate();
  const [formValues, setFormValues] = React.useState<any>([]);
  const [formTitle, setFormTitle] = React.useState<string>('');
  const fetch = async () => {
    const resp = await HttpService.getAxiosClient().get(`/forms/${params.id}`);
    setFormTitle(resp.data?.appl_title_naming.title);
    setIsLoading(false);
    setFormValues(resp?.data?.form_stacture || []);
  };
  React.useEffect(() => {
    fetch();
  }, []);

  return (<>
    <TitleLayout>
      <Typography variant='h2'>Προεπισκόπηση Φόρμας</Typography>
      <Box mt={2} mb={2}>
        <BackButton onClick={() => navigate('/admin/applications')} />
      </Box>
    </TitleLayout>
    <SkeletonWrapper loading={isLoading} skeletonLines={6}>
      <Card style={{
        backgroundColor: '#ffffff',
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        padding: '16px'
      }}>
        <Typography variant='h3' sx={{ display: 'flex', justifyContent: 'center' }}>
          {formTitle}
        </Typography>
        <Divider sx={{ m: 3 }} />
        <Box p={2}>
          <RenderForm metadataArray={formValues} />
        </Box>
      </Card>
    </SkeletonWrapper>
  </>);
}

export default ViewFromScratchRequest;